import { Store } from "@/store/state";
import { computed, ComputedRef } from "vue";
import { useStore } from "vuex";

export const useComputedValue = <T = any>(getter: string): ComputedRef<T> => {
  const { getters } = useStore<Store>();
  return computed<T>(() => getters[getter]);
};
